import { inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { loadTopicsSuccess } from '../../../project/modules/project-monitoring/store/monitoring.actions';

export const resetTopicsGuard = () => {
  const store = inject<Store>(Store);
  store.dispatch(loadTopicsSuccess({ topics: [] }));
  return true;
};
